import IOT_Rover from "../Assets/Projects/IOT_Rover.png";
import TaskManager from "../Assets/Projects/TaskManager.png";
import JSONIFY from "../Assets/Projects/JSONIFY.png";

// Projects below without a real screenshot use `image: null` and render a
// designed gradient cover instead. Drop a screenshot into src/Assets/Projects/,
// import it here, and set `image:` to swap the cover for the real thing.
const Agent = null;
const SMA = null;
const SMH = null;
const HRM = null;
const GS_A = null;
const CUSTFMS = null;

export const SITE = {
  name: "Muhammad Abdullah Shakoor",
  shortName: "MAS",
  role: "Full Stack Developer",
  tagline:
    "I build end-to-end software, AI, IoT and data-driven products — from system architecture to production.",
  location: "Islamabad, Pakistan",
  email: "abdullahshakoor1000@gmail.com",
  phone: "+92 316 5016221",
  resumeNote: "Full Stack · AI/ML · IoT",
};

export const SOCIALS = [
  {
    label: "GitHub",
    href: "https://github.com/m-abdullah-shakoor",
    icon: "github",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/muhammad-abdullah-shakoor/",
    icon: "linkedin",
  },
  { label: "X", href: "https://x.com/Abd__20__01/", icon: "twitter" },
  {
    label: "Instagram",
    href: "https://www.instagram.com/being_abd_allah_2001/",
    icon: "instagram",
  },
];

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "resume", label: "Resume" },
  { id: "contact", label: "Contact" },
];

export const ROLES = [
  "Full Stack Developer",
  "AI & Automation Engineer",
  "IoT & Embedded Systems",
  "ML & Data Engineer",
];

export const STATS = [
  { value: "3+", label: "Years building software" },
  { value: "15+", label: "Projects built" },
  { value: "6+", label: "Production deployments" },
  { value: "∞", label: "Cups of chai" },
];

export const FACTS = [
  { k: "Focus", v: "Software Engineering, Full Stack, AI/ML" },
  { k: "Also build", v: "IoT, Robotics & Embedded Systems" },
  { k: "Core languages", v: "C++, JavaScript, Python" },
  { k: "Also into", v: "Technical writing & theology" },
];

export const SKILLS = [
  {
    group: "Frontend",
    items: [
      "React",
      "Next.js",
      "JavaScript (ES6+)",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
      "Bootstrap",
    ],
  },

  {
    group: "Backend & APIs",
    items: ["Node.js", "Express.js", "FastAPI", "REST APIs"],
  },

  {
    group: "Databases",
    items: ["MongoDB", "MySQL", "PostgreSQL", "Supabase"],
  },

  {
    group: "AI & Machine Learning",
    items: [
      "Python",
      "TensorFlow",
      "scikit-learn",
      "Pandas",
      "NumPy",
      "LLMs",
      "AI Agents",
      "Tool Calling",
      "Ollama",
      "Model Evaluation",
    ],
  },

  {
    group: "Data & Automation",
    items: [
      "Data Analysis",
      "Web Scraping",
      "Data Processing",
      "Data Visualization",
      "Pandas",
      "NumPy",
      "Google Sheets Automation",
      "Google Apps Script",
      "API Integration",
    ],
  },

  {
    group: "Embedded & IoT",
    items: [
      "C++",
      "ESP32",
      "Arduino",
      "Raspberry Pi",
      "IoT",
      "Real-time Streaming",
    ],
  },

  {
    group: "DevOps & Development Tools",
    items: [
      "Git",
      "GitHub",
      "GitLab",
      "Docker",
      "Linux",
      "Vercel",
      "Postman",
      "VS Code",
    ],
  },

  {
    group: "Design & Productivity",
    items: ["Figma", "EasyEDA", "Notion"],
  },
];

export const PROJECTS = [
  {
    title: "Personalized AI Assistant - ORION",
    image: Agent,
    featured: true,
    description:
      "A personalized, tool-augmented AI assistant with contextual memory and retrieval. ORION connects an LLM to external tools and APIs to answer in context, automate multi-step tasks and workflows, and take actions across connected services — with local model experimentation via Ollama.",
    tech: [
      "Python",
      "LLMs",
      "Tool Calling",
      "Ollama",
      "MongoDB",
      "Google APIs",
    ],
    github: "https://github.com/m-abdullah-shakoor/NinjaBot",
    demo: "",
  },
  {
    title: "Social Media Scraping & Analysis Platform",
    image: SMA,
    featured: true,
    description:
      "A full-stack data pipeline for collecting, processing, and analyzing social media data. It extracts content using dynamic keywords, structures raw data, and visualizes insights through interactive dashboards for trend and sentiment analysis.",
    tech: ["React", "Python", "Web Scraping", "Data Analysis", "APIs"],
    github: "https://github.com/m-abdullah-shakoor/Scraper",
    demo: "",
  },
  {
    title: "FYP Management System",
    image: CUSTFMS,
    featured: false,
    description:
      "A real-time management platform for final-year academic projects. Students submit proposals and progress reports; supervisors review, approve, and evaluate them through a role-based dashboard.",
    tech: ["React", "Node.js", "Express", "MongoDB", "Socket.io"],
    github: "https://github.com/m-abdullah-shakoor/CUST-FMS-FE",
    demo: "",
  },
  {
    title: "CAM Rover",
    image: IOT_Rover,
    featured: false,
    description:
      "An IoT-based remote surveillance and control system powered by an ESP32 microcontroller and L298N motor driver. It enables remote maneuvering with live video streaming through a network-connected interface.",
    tech: ["ESP32", "C++", "IoT", "L298N", "Web Interface"],
    github: "https://github.com/m-abdullah-shakoor/ESP32_FINEST",
    demo: "",
  },
  {
    title: "Social Media Health Monitoring Dashboard",
    image: SMH,
    featured: false,
    description:
      "A unified analytics dashboard for monitoring digital presence across Twitter, YouTube, Instagram, and Facebook. It aggregates platform metrics, tracks engagement trends, and provides comparative insights into social reach and audience growth.",
    tech: ["React", "Node.js", "Python", "APIs", "Data Visualization"],
    github: "https://github.com/m-abdullah-shakoor/Scraper",
    demo: "",
  },
  {
    title: "Customer Churn Prediction Model",
    image: null,
    featured: false,
    description:
      "A machine-learning project that analyses telecom customer behaviour to predict churn probability. It compares multiple classification algorithms, evaluates them on standard performance metrics, and surfaces the key factors driving customer attrition.",
    tech: ["Python", "scikit-learn", "Pandas", "Model Evaluation", "ML"],
    github: "https://github.com/m-abdullah-shakoor/IDSPR",
    demo: "",
  },
  {
    title: "HR Management & Geofencing System",
    image: HRM,
    featured: false,
    description:
      "A full-stack HR management system featuring geofencing-based attendance tracking. Employees can check in and out within defined geographic boundaries while administrators manage employees, attendance, and operational data through dashboards.",
    tech: ["React", "Node.js", "Express", "MongoDB", "Geofencing"],
    github: "https://github.com/m-abdullah-shakoor/EMS",
    demo: "",
  },
  {
    title: "Chat API",
    image: null,
    featured: false,
    description:
      "A real-time chat API providing group and private messaging with message history, typing indicators and read receipts — designed to drop into any web or mobile client.",
    tech: ["Node.js", "Socket.io", "MongoDB", "REST APIs", "JWT"],
    github: "https://github.com/m-abdullah-shakoor/realtime-chat-api",
    demo: "",
  },
  {
    title: "Google Sheets Automation",
    image: GS_A,
    featured: false,
    description:
      "A Node.js-based automation system that processes data from spreadsheets to trigger intelligent workflows. It dynamically interprets input data, generates responses, and sends notifications through SMS to reduce manual effort.",
    tech: ["Node.js", "Google Sheets", "Google Apps Script", "SMS API"],
    github: "https://github.com/m-abdullah-shakoor/Airtable_Automation",
    demo: "https://airtable-automation.vercel.app/",
  },
  {
    title: "Task Manager",
    image: TaskManager,
    featured: false,
    description:
      "A full-stack task management application built with the MERN stack. It enables users to create, update, and track tasks with deadline management, progress tracking, and a responsive interface.",
    tech: ["React", "Node.js", "Express", "MongoDB"],
    github: "https://github.com/m-abdullah-shakoor/TaskManager",
    demo: "https://task-manager-fe-virid.vercel.app",
  },
  {
    title: "JSONIFY",
    image: JSONIFY,
    featured: false,
    description:
      "A web-based JSON editor and viewer designed for efficient data manipulation. It provides syntax highlighting, real-time validation, and error detection while supporting data export for development workflows.",
    tech: ["React", "JavaScript", "JSON", "Syntax Highlighting"],
    github: "https://github.com/m-abdullah-shakoor/Jsonify_FE",
    demo: "https://jsonify-fe.vercel.app",
  },
];

export const CONTACT_ENDPOINT =
  process.env.REACT_APP_CONTACT_ENDPOINT ||
  "https://messaging-api-three.vercel.app/api/send-email";
